module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.1d5bb5c6.woff";